import { render } from "./NumbersSection.vue?vue&type=template&id=dc3857f2&scoped=true"
import script from "./NumbersSection.vue?vue&type=script&lang=js"
export * from "./NumbersSection.vue?vue&type=script&lang=js"

import "./NumbersSection.vue?vue&type=style&index=0&id=dc3857f2&scoped=true&lang=css"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/VibeLab/XP/Xp mircosite/xp-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc3857f2"]])

export default __exports__